// extracted by mini-css-extract-plugin
export var fadeIn = "_ep-1";
export var modalContent = "_ep-3";
export var overlay = "_ep-0";
export var popoverContent = "_ep-2";
export var results = "_ep-5";
export var searchInputWrapper = "_ep-4";